/* src/app/buy-vouchers/buy-vouchers.component.scss */
:host {
  --page-bg: #efeee2;
  --card-bg: #fbfaed;
  display: block;
  min-height: 100vh;
  background-color: var(--page-bg);
}
.border-button {
  border-radius: 24px;
}
.amounts {
  width: 100%;
}
.amounts .amount {
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  display: flex;
}
.amounts .primary {
  font-size: 18px;
  color: var(--primary);
}
.amounts .value {
  min-width: 64px;
}
.amounts P {
  margin-left: 6px;
}
.wrapper {
  padding: 8px;
  background: transparent;
}
.wrapper .general-terms {
  position: relative;
  top: -16px;
  margin-bottom: 8px;
}
.wrapper .general-terms a {
  color: var(--primary);
}
.wrapper .general-terms .terms-link-info::after {
  width: 210px;
  content: "Door op deze link te klikken wordt er een nieuw tabblad geopend.";
}
.wrapper a.terms-link {
  display: block;
  font-size: 14px;
  margin-top: 8px;
}
.wrapper a.terms-link + a.terms-link {
  margin-top: 12px;
}
.wrapper .voucher-terms mat-label {
  color: rgba(0, 0, 0, 0.6) !important;
}
.wrapper .voucher-terms textarea {
  color: rgba(0, 0, 0, 0.87) !important;
}
.wrapper .textarea-positioning .textarea {
  width: 100%;
  color: transparent !important;
}
.wrapper .terms-checkbox-container {
  margin-bottom: 12px;
}
.wrapper .gift-wrapping-checkbox {
  margin-left: -10px;
  margin-bottom: 20px;
}
.wrapper .delivery-position {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.wrapper .step {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.wrapper .stepper-container-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 24px 0 32px;
}
.wrapper .stepper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.wrapper .stepper-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 0 0 100px;
}
.wrapper .stepper-step {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  transition: all 0.3s ease;
}
.wrapper .stepper-active-step {
  background-color: var(--primary);
  color: white;
  border: 2px solid var(--primary);
}
.wrapper .stepper-inactive-step {
  background-color: var(--card-bg);
  color: #777;
  border: 2px solid #ccc;
}
.wrapper .stepper-label {
  margin-top: 8px;
  font-size: 13px;
  font-weight: 550;
  color: #40484b;
  text-align: center;
}
.wrapper .stepper-line {
  flex-grow: 1;
  height: 3px;
  background-color: #ccc;
  align-self: flex-start;
  margin-top: 17px;
  position: relative;
  z-index: 1;
  margin-left: -32px;
  margin-right: -32px;
}
.wrapper .stepper-line.active {
  background-color: var(--primary);
}
.wrapper .button-back {
  color: var(--primary);
}
.wrapper .activate-card {
  margin: auto;
  width: 100%;
  max-width: 1000px;
  box-shadow: none;
}
.wrapper .activate-card .imgWrapper {
  text-align: center;
}
.wrapper .activate-card .imgWrapper .logo {
  height: 90px;
  content: var(--logo-fullwidth);
  margin-bottom: 12px;
}
.wrapper .activate-card .title {
  margin-bottom: 16px;
  font-size: 26px;
  text-align: center;
  color: var(--primary);
}
.wrapper .activate-card .statistics {
  left: 0;
  right: 0;
  margin: auto;
  top: 40px;
  max-width: 200px;
}
.wrapper .activate-card .statistics .statistic {
  font-size: 50px;
  text-align: center;
  color: var(--primary);
}
.wrapper .activate-card .statistics .subtitle {
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
}
.wrapper .step-1-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.loading-wrapper {
  height: 100vh;
  width: 100vw;
}
.loading-wrapper .loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-top-color: #000000;
  animation: spinner 0.8s linear infinite;
}
.flex-buttons {
  flex: 1 1 0%;
  box-sizing: border-box;
  flex-direction: row;
  display: flex;
  margin-bottom: 24px;
}
.flex-spacer {
  flex: 1 1 0%;
  box-sizing: border-box;
}
.formfield-width-100 {
  width: 100%;
}
.spacing-flex {
  flex-grow: 1;
}
.buttons {
  display: flex;
  margin-bottom: 24px;
}
.step-container {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
  align-items: flex-start;
}
.step-main-col {
  flex: 1 1 500px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.step-side-col {
  flex: 1 1 300px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}
.form-col {
  flex: 1 1 calc(50% - 8px);
  min-width: 240px;
}
.address-row-3 {
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: flex-start;
}
@media screen and (max-width: 480px) {
  .address-row-3 {
    flex-wrap: wrap;
    gap: 8px;
  }
}
.postal-col {
  flex: 2 1 140px;
}
@media screen and (max-width: 480px) {
  .postal-col {
    flex: 1 1 100%;
  }
}
.number-col {
  flex: 1.5 1 100px;
}
@media screen and (max-width: 480px) {
  .number-col {
    flex: 1 1 calc(60% - 4px);
  }
}
.addition-col {
  flex: 1 1 80px;
}
@media screen and (max-width: 480px) {
  .addition-col {
    flex: 1 1 calc(40% - 4px);
  }
}
.step-card {
  background-color: var(--card-bg) !important;
  border: 1px solid black !important;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}
.step-card .titles {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 16px;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;
}
.step-card.step-card-sidebar {
  height: auto;
}
.step-main-col > .step-card + .step-card {
  margin-top: 16px;
}
.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .step-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.step-header-text {
  flex: 1;
}
.step-header-text .titles {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #1a1a1a;
}
.step-header-text .subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.total-badge {
  background-color: var(--card-bg);
  color: var(--primary);
  border: 1px solid var(--primary);
  border-radius: 8px;
  padding: 6px 16px;
  text-align: center;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
}
.total-badge .total-badge-value {
  font-size: 16px;
  font-weight: bold;
}
.custom-radio-group {
  display: flex;
  gap: 16px;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 16px;
}
@media screen and (max-width: 599px) {
  .custom-radio-group {
    flex-direction: column;
    gap: 8px;
  }
}
::ng-deep .custom-radio-button {
  flex: 1;
  border: 1px solid #ccc !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  min-height: 54px;
  height: auto;
  box-sizing: border-box;
}
::ng-deep .custom-radio-button.mat-mdc-radio-button-checked {
  border-color: var(--primary) !important;
  border-width: 2px !important;
  background-color: var(--primary-95) !important;
}
::ng-deep .mat-mdc-flat-button.border-button {
  background-color: var(--primary) !important;
  color: white !important;
  border: 1px solid black !important;
  border-radius: 24px;
  padding: 8px 24px;
  font-weight: bold;
  height: 48px;
}
::ng-deep .mat-mdc-flat-button.border-button .mat-icon {
  margin-left: 8px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
::ng-deep .mat-mdc-flat-button.border-button:disabled {
  background-color: #cccccc !important;
  color: #666666 !important;
  border-color: #999999 !important;
}
.sidebar-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.sidebar-buttons button {
  width: 100%;
}
::ng-deep .voucher-terms .mat-mdc-text-field-wrapper,
::ng-deep .voucher-terms .mdc-text-field,
::ng-deep .voucher-terms .mdc-text-field--disabled,
::ng-deep .voucher-terms .mat-mdc-form-field-flex {
  background-color: var(--card-bg) !important;
}
::ng-deep .voucher-terms textarea {
  background-color: var(--card-bg) !important;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px !important;
  font-family: inherit;
  font-size: 14px;
}
/*# sourceMappingURL=buy-vouchers.component.css.map */
